import { connect } from 'react-redux';
import { compose } from 'recompose';
import RelativeGuides from '../../components/handoff/RelativeGuides';
import onlyIf from '../../hocs/onlyIf';
import { getElementLayoutForPercentage, getHoveredElementLayout, getPixelRatio, getSelectedElementLayout, isInHandoffMode, showRelativeGuides, } from '../../selectors/handoff';
function mapStateToProps(state) {
    if (!isInHandoffMode(state) || !showRelativeGuides(state)) {
        return {};
    }
    return {
        selectedElement: getSelectedElementLayout(state),
        hoveredElement: getHoveredElementLayout(state),
        relativeElement: getElementLayoutForPercentage(state),
        pixelRatio: getPixelRatio(state),
    };
}
export default compose(connect(mapStateToProps, null), onlyIf(function (props) { return props.hoveredElement; }))(RelativeGuides);
